// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 392) return "ui/front/dist/gift-card-page.js";
	if (chunkId === 312) return "ui/front/dist/NbgEEIFrame.js";
	// return url for filenames based on template
	return "" + "/ui/front/dist/vendor" + ".js";
};